import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import AutoComplete from '../../../../components/AutoComplete'

import { getPostIndexRef, getFolderIndexRef } from '../../../../config/firebase';
import { deepLinkingScheme } from '../../../../config/settings';
import { getAllItems } from '../../../../utils';
import CopyToClipboard from '../../components/CopyToClipboard';

const styles = theme => ({
  formControl: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 3,
    minWidth: 120,
  },
});

class LinkGenerator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedType: '',
      selectedItem: '',
      folderOptions: [],
      postOptions: [],
    }

    this.postsRef = getPostIndexRef('public');
    this.foldersRef = getFolderIndexRef();

    this.handleTypeChange = this.handleTypeChange.bind(this)
    this.handleItemChange = this.handleItemChange.bind(this)
  }

  componentDidMount() {
    getAllItems(this.postsRef, (posts) => {
      const postOptions = posts.map(({ id, title }) => {
        return { value: id, label: title };
      });

      this.setState({ postOptions });
    });

    getAllItems(this.foldersRef, (folders) => {
      const folderOptions = folders.map(({ id, title }) => {
        return { value: id, label: title };
      });

      this.setState({ folderOptions });
    });
  }

  componentWillUnmount() {
    this.postsRef.off();
    this.foldersRef.off();
  }

  handleTypeChange(selectedType) {
    this.setState({ selectedType, selectedItem: '' })
  }

  handleItemChange(selectedItem) {
    this.setState({ selectedItem })
  }

  render() {
    const {
      selectedType,
      selectedItem,
      postOptions,
      folderOptions,
    } = this.state;

    const tabSelect = selectedType === 'tabs'
      ? (
        <FormControl className={this.props.classes.formControl}>
          <InputLabel htmlFor="tab-select">Tab</InputLabel>
          <Select
            value={selectedItem}
            onChange={this.handleItemChange}
            inputProps={{
              name: 'tab',
              id: 'tab-select',
            }}
          >
            <MenuItem value="resources">Resources</MenuItem>
            <MenuItem value="practices">Practices</MenuItem>
            <MenuItem value="guidedMeditation">Guided Meditation</MenuItem>
            <MenuItem value="dharmaTalks">Ask Thay</MenuItem>
            <MenuItem value="bellOfMindfulness">Bell of Mindfulness</MenuItem>
          </Select>
        </FormControl>
      )
      : null;

    const folderSelect = selectedType === 'posts'
      ? (
        <AutoComplete
          label="Post"
          options={postOptions}
          selected={postOptions.find(o => o.value === selectedItem)}
          onChange={this.handleItemChange}
        />
      )
      : null;

    const postSelect = selectedType === 'folders'
      ? (
        <AutoComplete
          label="Folder"
          options={folderOptions}
          selected={folderOptions.find(o => o.value === selectedItem)}
          onChange={this.handleItemChange}
        />
      )
      : null;

    let uriComponent = null;

    if (selectedType && selectedItem) {
      const uri = `${deepLinkingScheme}${selectedType}/${selectedItem}`;
      uriComponent = <CopyToClipboard text={uri} />;
    }

    return (
      <div>
        <FormControl className={this.props.classes.formControl}>
          <InputLabel htmlFor="screen-type">Screen type</InputLabel>
          <Select
            value={selectedType}
            onChange={(event) => this.handleTypeChange(event.target.value)}
            inputProps={{
              name: 'type',
              id: 'screen-type',
            }}
            fullWidth
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            <MenuItem value="tabs" disabled>Tabs (not supported yet)</MenuItem>
            <MenuItem value="folders">Folders</MenuItem>
            <MenuItem value="posts">Posts</MenuItem>
          </Select>
        </FormControl>
        {tabSelect}
        {folderSelect}
        {postSelect}
        {uriComponent}
      </div>
    )
  }
}

export default withStyles(styles)(LinkGenerator);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/LinkGenerator/index.js